import React, { useEffect, useState } from "react";
import SelectMUI from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "../TextField";
import Autocomplete from "../Autocomplete";
import styles from "./index.module.scss";
import ClassNames from "classnames";

// list items should have the following properties: "value" and "label"
export default function Select({
  list,
  value,
  disabled,
  onChange,
  className,
  groupBy = false,
  variant = "outlined",
  error,
  helperText,
  searchable = false,
  noMargin = false,
  ...props
}) {
  const [selectedValue, setSelectedValue] = useState(null);

  useEffect(() => {
    if (list && value && searchable) {
      const currentValue = list.filter(item => item.value === value);
      setSelectedValue(currentValue[0] ? currentValue[0] : null);
    } else {
      setSelectedValue(null);
    }
  }, [list, value]);
  return (
    <FormControl style={{ display: "flex" }} error={error} color="secondary">
      {!searchable && (
        <SelectMUI
          className={ClassNames(className, styles.selector)}
          variant={variant}
          value={value}
          onChange={onChange}
          disabled={disabled}
          {...props}
        >
          {props.placeholder && (
            <MenuItem key="placeholder" value="_empty" disabled>
              {props.placeholder}
            </MenuItem>
          )}

          {list.map((item, i) => {
            return (
              <MenuItem key={i} value={item.value}>
                {item.label}
              </MenuItem>
            );
          })}
        </SelectMUI>
      )}
      {searchable && (
        <Autocomplete
          id="searchableSelect"
          className={ClassNames(className, styles.searchableSelector, {
            [styles.noMargin]: noMargin,
          })}
          disableClearable
          name={props.name}
          value={selectedValue}
          onChange={(event, newValue) => {
            setSelectedValue(newValue);
            const newEvent = { target: { value: newValue.value } };
            onChange(newEvent);
          }}
          options={list}
          getOptionLabel={option => option?.label}
          groupBy={groupBy ? option => option["groupBy"] : ""}
          renderInput={params => (
            <TextField {...params} placeholder="Select one" variant={variant} />
          )}
        />
      )}
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
